import { buildLovTypesQuery } from './lov-query'
import { DEFAULT_LOV_LIST_URL } from './default-fetch'
import { extractLovListRows } from './normalize'

import type { LovConfigContext } from './types'

/** LOV 编辑弹窗：GET /system/lov/getLovList?lovTypes= */
export async function defaultFetchLovList(
  lovType: string
): Promise<Record<string, unknown>[]> {
  if (!lovType) {
    return []
  }
  const query = buildLovTypesQuery([lovType])
  const res = await fetch(`${DEFAULT_LOV_LIST_URL}?${query}`)
  if (!res.ok) {
    throw new Error(`LOV list request failed: ${res.status}`)
  }
  const json = await res.json()
  return extractLovListRows(json, lovType)
}

export function resolveFetchLovList(
  lovConfig?: LovConfigContext
): (lovType: string) => Promise<Record<string, unknown>[]> {
  return lovConfig?.fetchLovList ?? defaultFetchLovList
}
